import Grading from "../../Pages/Grading";
import { navigationMapBuilder } from "./helpers";

const navigation = [
  {
    header: "Grading",
    links: [
      {
        text: "Grading",
        icon: <></>,
        route: "",
        component: Grading,
      },
    ],
  },
];

const navigationMap = (parentRoute,layout) =>
  navigationMapBuilder(parentRoute, navigation,layout);


export default navigationMap;
